import FullLayout from '@/modules/core/layouts/FullLayout.vue';
import ViewParceiro from './ViewParceiro.vue';
import AddParceiro from './AddParceiro.vue';
import EditParceiro from './EditParceiro.vue';

export default {
  path: '/admin',
  component: FullLayout,
  meta: { requiresAuth: true },
  children: [
    { name: 'parceiro', path: 'parceiros', component: ViewParceiro },
    { name: 'novoParceiro', path: 'parceiros/0', component: AddParceiro },
    { props: true, name: 'editarParceiro', path: 'parceiros/:id', component: EditParceiro },
  ],
};
